<template>
  <div>
    <button id="shared-step-editor-header-close" class="shared-step-editor-header-close" @click="onOpen">
      <img
        src="/wp-content/themes/snappy-theme/assets/images/builders/close.svg"
        alt="Close"
        class="shared-step-editor-header-close__icon"
      />
    </button>
    <shared-step-editor-modal
      :open="open"
      :width="430"
      title="Are you sure you want to quit?"
      closeText="Close"
      confirmText="Confirm"
      @confirm="onConfirm"
      @close="open = false"
      >All unsaved progress will be lost</shared-step-editor-modal
    >
  </div>
</template>

<script>
import SharedStepEditorModal from './SharedStepEditorModal';
export default {
  components: {SharedStepEditorModal},
  props: {
    confirmation: Boolean,
  },
  data: () => ({
    open: false,
  }),
  methods: {
    onOpen() {
      if (this.confirmation) {
        this.open = true;
      } else {
        this.onConfirm();
      }
    },
    onConfirm() {
      this.$emit('confirm');
      this.open = false;
    },
  },
};
</script>

<style lang="scss">
.shared-step-editor-header-close {
  cursor: pointer;
  &,
  &:hover {
    background: transparent;
    border: 0;
    outline: 0;
  }
  &__icon {
    height: inherit;
    height: 15px;
    width: 15px;
  }
  &__cancel {
    margin-right: 20px;
  }
  &__content {
    font-size: 15px;
  }
}
</style>
